export default __webpack_public_path__ + "static/media/guidaMichelin.e917e390.avif";